// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2b17afd9","581":"2bfe0b7f","732":"193dbffa","977":"4db89900"}[chunkId] + ".chunk.js";
};